export const CLUB_BILLING_FIELD_KEYS = [
  "legalName",
  "gstin",
  "pan",
  "billingAddress",
  "state",
];

export const GSTIN_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

export const INDIAN_STATES_AND_UTS = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const EMPTY_CLUB_BILLING = Object.fromEntries(
  CLUB_BILLING_FIELD_KEYS.map((k) => [k, ""])
);

/** Normalize GET /club/admin/:id billing fields (top-level or nested `billing`). */
export function pickClubBillingFromClub(raw) {
  if (!raw || typeof raw !== "object") return { ...EMPTY_CLUB_BILLING };
  const nested =
    raw.billing && typeof raw.billing === "object" ? raw.billing : {};
  const out = { ...EMPTY_CLUB_BILLING };
  CLUB_BILLING_FIELD_KEYS.forEach((k) => {
    const v = raw[k] ?? nested[k];
    if (v != null) out[k] = String(v).trim();
  });
  return out;
}

/** Client-side validation before PUT /club/website/:id (all billing fields required). */
export function validateClubBilling(billing, t) {
  const errors = {};
  const legalName = String(billing?.legalName ?? "").trim();
  const gstin = String(billing?.gstin ?? "").trim().toUpperCase();
  const pan = String(billing?.pan ?? "").trim().toUpperCase();
  const billingAddress = String(billing?.billingAddress ?? "").trim();
  const state = String(billing?.state ?? "").trim();

  if (!legalName) {
    errors.legalName = t("CLUB_BILLING_LEGAL_NAME_REQUIRED");
  } else if (legalName.length > 300) {
    errors.legalName = t("CLUB_BILLING_LEGAL_NAME_INVALID");
  }

  if (!gstin) {
    errors.gstin = t("CLUB_BILLING_GSTIN_REQUIRED");
  } else if (!GSTIN_REGEX.test(gstin)) {
    errors.gstin = t("CLUB_BILLING_GSTIN_INVALID");
  }

  if (!pan) {
    errors.pan = t("CLUB_BILLING_PAN_REQUIRED");
  } else if (!PAN_REGEX.test(pan)) {
    errors.pan = t("CLUB_BILLING_PAN_INVALID");
  }

  if (!billingAddress) {
    errors.billingAddress = t("CLUB_BILLING_ADDRESS_REQUIRED");
  } else if (billingAddress.length > 1000) {
    errors.billingAddress = t("CLUB_BILLING_ADDRESS_TOO_LONG");
  }

  if (!state) {
    errors.state = t("CLUB_BILLING_STATE_REQUIRED");
  } else if (state.length > 120) {
    errors.state = t("CLUB_BILLING_STATE_TOO_LONG");
  }

  return errors;
}

/** Build flat billing keys for PUT /club/website/:id. */
export function buildClubBillingPutFields(billing) {
  const out = {};
  CLUB_BILLING_FIELD_KEYS.forEach((k) => {
    let v = billing?.[k] != null ? String(billing[k]).trim() : "";
    if (k === "gstin" || k === "pan") v = v.toUpperCase();
    out[k] = v;
  });
  return out;
}
